import React, { Component } from 'react';
import { Collapse, CardBody, Card, Table, Container } from 'reactstrap';
import { Grid } from '@material-ui/core';

export class PaymentHistory extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false,
        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }
    renderTableData = () => {
        const renderValue = this.props.bill.invoices;
        if (renderValue !== undefined) {
            const sortedRenderValue = [].concat(renderValue).reverse()
            return sortedRenderValue.map((payment, index) => {
                const { paymentDate, paymentAmount, status } = payment //destructuring
                let date = paymentDate.split('-');
                date = date[2] + '/' + date[1] + '/' + date[0]
                let Status = '';
                (status == "PAID") ? (Status = "Webmail service paid") : (Status = status);
                return (
                    <tr key={index}>
                        <td>{date}</td>
                        <td>{Status}</td>
                        <td>€{paymentAmount / 100}</td>
                        <td>€{((paymentAmount / 100) / 1.23).toFixed(2)}</td>
                    </tr>
                )
            })

        }

    }


    render() {
        return (
            <div className="collapsible-main payment-history">
                <div onClick={this.toggle}>
                    <h4 className="collapsible-header">Payment History </h4>

                    {this.state.isOpen && <span className="inclusive-Vat">Inclusive of standard rated VAT</span>}

                    <span> {
                        this.state.isOpen ? <a href='javascript:;' className="eir-icon chevron-arrow icon-arrowup--purple float-right"> </a> : <a href='javascript:;' className="eir-icon chevron-arrow icon-arrowdown--purple float-right"> </a>
                    }</span>
                </div>
                <Collapse isOpen={this.state.isOpen}>
                    <br />
                    <div className="collapsible-item">
                        <Table>
                            <thead>
                                <tr>
                                    <th>Payment Date</th>
                                    <th>Status</th>
                                    <th>Gross Amount</th>
                                    <th>Net Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderTableData()}
                            </tbody>
                        </Table>
                    </div>
                </Collapse>
            </div>
        )
    }
}

export default PaymentHistory
